import React from 'react';
import {
  Button,
  Modal,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Spin,
  Table,
  Select,
  TextArea,
  DatePicker,
} from 'antd';
import { DeleteOutlined, EditOutlined, AuditOutlined } from '@ant-design/icons';
import { useEffect, useState, useRef } from 'react';
import { API, BEARER } from '../../constant';
import ItemListDisplay from '../../components/ItemList/ItemListDispaly';
import { getToken } from '../../helpers';
import { CSVLink } from 'react-csv';
import {
  useNavigate,
  Link,
  useSearchParams,
  useLocation,
} from 'react-router-dom';
import { getMonthNameFromStringDate, dateFormat } from '../../utils/dateUtils';
import {
  fabricLiabilityStatusArray,
  deleteTypeOptionArray,
  getEligibleOPtionforDeleteType,
  toProperCase,
} from '../../utils/generic';
import moment from 'moment';
import CoreProductDetails from '../CoreProduct/CoreProductDetailsNew';
import { errorHandler } from '../../utils/errorHandling';
import { DeleteRequestFactory } from '../../utils/DeleteRequestFactory';
const PRODUCTSTAGE = [6, 7, 8];
const userRoleAndPermission = require('../../config/userPermision.json');

const userRolesAllowedForAttributes = {
  edit: {
    designAttribute: [
      ...userRoleAndPermission?.userRole?.designTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    merchAttribute: [
      ...userRoleAndPermission?.userRole?.merchTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
    planningAttribute: [
      ...userRoleAndPermission?.userRole?.planningTeamRole,
      ...userRoleAndPermission?.userRole?.adminTeamRole,
    ],
  },
  view: {},
};

const launchNameFilterFunciton = (value, searchText) => {
  let flag = false;
  value?.launchDetails?.forEach((launch) => {
    console.log(
      launch?.launchName,
      'value - ',
      launch?.launchName
        ?.toLowerCase()
        .includes(searchText?.trim().toLowerCase())
    );
    if (
      launch?.launchName
        ?.toLowerCase()
        .includes(searchText?.trim().toLowerCase())
    ) {
      flag = true;
    }
  });
  return flag;
};

const filterGlobalSearch = (Data, searchText, filterScope) => {
  if (!searchText) {
    return Data;
  }

  let filteredDataTemp = [];
  if (filterScope == 'all') {
    filteredDataTemp = Data.filter((value) => {
      console.log(value);
      return (
        value?.launchDrop
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        value?.month?.toLowerCase().includes(searchText.trim().toLowerCase()) ||
        value?.sku?.toLowerCase().includes(searchText.trim().toLowerCase()) ||
        value?.productOptionType?.productCatName
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase()) ||
        value?.object_status
          ?.toLowerCase()
          .includes(searchText.trim().toLowerCase())
      );
    });
  } else if (filterScope == 'launchDrop') {
    filteredDataTemp = Data.filter((value) => {
      return value?.launchDrop
        ?.toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  } else if (filterScope == 'launch_masters') {
    filteredDataTemp = Data.filter((value) => {
      console.log('searchValue:', searchText, value);
      return launchNameFilterFunciton(value, searchText);
    });
  } else if (filterScope == 'month') {
    filteredDataTemp = Data.filter((value) => {
      console.log('searchValue:', searchText, value);
      return value?.month
        ?.toLowerCase()
        .includes(searchText.trim().toLowerCase());
    });
  }

  console.log(filteredDataTemp, 'filtered data', filterScope, searchText);
  if (filteredDataTemp.length > 0) {
    return filteredDataTemp;
  } else {
    filteredDataTemp.push({
      key: 0,
      id: 0,
      month: 'Not Found',
      launchDrop: 'Not Found',
      quantity: 'Not Found',
      sku: 'Not Found',
      sleeve: 'Not Found',
      assumedMRP: 'Not Found',
      status: 'Not Found',
      new_Repeat: 'Not Found',
      productOptionType: {
        productCatName: 'Not Found',
        productCatRefId: 0,
      },
      launchDetails: [],
      indentSheetDetails: [],
      techpackDetails: [],
      fabricUtilizationDetails: [],
    });
    return filteredDataTemp;
  }
};

const BookableProductList = ({ tabKey }) => {
  const tabName = tabKey;
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPageName = searchParams.get('pageName');
  const currentPage =
    (currentPageName === tabName && parseInt(searchParams.get('page'), 10)) ||
    1;
  const searchString = searchParams?.get('searchquery') || '';
  const [paginationData, setPaginationData] = useState({});
  // pagination object data for configuration.
  const [paginationParams, setPaginationParams] = useState({});
  // pagination parameter changed by user

  // CSV Export
  const [downloadableData, setDownloadableData] = useState([]);
  const csvLinkRef = useRef();

  const [isDownloading, setIsDownloading] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bookingForm] = Form.useForm();
  const [editBookingData, setEditBookingData] = useState(null);
  const [supplierList, setSupplierList] = useState([]);

  //  ------------delete--form-----
  {
    /* delete product with comment */
  }
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [cancelProductForm] = Form.useForm();
  const [editProductDeleteData, setEditProductDeleteData] = useState(null);
  const [deleteTypeOptionsList, setDeleteTypeOptionsList] = useState(null);
  //  ------------end-delete--form-----

  const [isLoading, setIsLoading] = useState(null);
  const [saving1, setIsLoading1] = useState(null);

  const authToken = getToken();
  const [Data, setData] = useState([]);

  const [filterInfo, setFilterInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState('');

  const [searchText, setSearchText] = useState(searchString || null);
  const [filterScope, setFilterScope] = useState('all');

  const filterScopeOptionsArray = [
    'all',
    'launchDrop',
    'month',
    'launch_masters',
  ];

  const [alreadySelectedRows, setAlreadySelectedRows] = useState([]);
  const [isIndentModalOpen, setIsIndentModalOpen] = useState(false);
  const [indentList, setIndentList] = useState([]);

  const [isTechpackModalOpen, setIsTechpackModalOpen] = useState(false);
  const [techpackList, setTechpackList] = useState([]);

  console.log(location);
  // not used
  // let searchPLaunchName = searchParams?.get('launchName')
  //   ? searchParams.get('launchName')
  //   : null;
  // console.log(searchPLaunchName);

  const [saving, setSaving] = useState(false);

  const toCoreProductDetails = (state) => {
    navigate('/coreProductDetails', { state });
  };

  let data1 = [];

  const getUserdDetailsCreatedBy = async (entry, contentTypeName) => {
    const userDetailsResponse = await fetch(
      `${API}/auditlogs?filters[$and][0][contentType][$eq]=${contentTypeName}&filters[$and][0][activity][$eq]=create&filters[$and][0][resourceId][$eq]=${entry?.id}&sort=createdAt:desc`,
      {
        headers: { Authorization: `${BEARER} ${getToken()}` },
      }
    );
    const userDetailsResponseData = await userDetailsResponse.json();
    console.log(
      userDetailsResponseData,
      'userDetailsResponse check',
      'Resouce Details',
      entry?.id
    );

    return {
      userRefId: userDetailsResponseData?.data[0]?.attributes?.user?.id,
      userName: userDetailsResponseData?.data[0]?.attributes?.user?.username,
      userEmail: userDetailsResponseData?.data[0]?.attributes?.user?.email,
    };
  };

  const fetchDataAll = async (token) => {
    try {
      setIsDownloading(true);
      const requestedAdditionalDetails = {
        populate: [
          {
            relation: 'launch_masters',
            populate: [
              {
                relation: 'season',
                populate: null,
              },
            ],
          },
          {
            relation: 'product_option_type',
            populate: null,
          },
          {
            relation: 'collection',
            populate: null,
          },
          {
            relation: 'indent_sheets',
            populate: null,
          },
          {
            relation: 'techpacks',
            populate: null,
          },
          {
            relation: 'sub_color_lists',
            populate: [
              {
                relation: 'filter_color',
                populate: null,
              },
            ],
          },
          {
            relation: 'fits_list',
            populate: null,
          },
          {
            relation: 'size_list',
            populate: null,
          },
          {
            relation: 'design_season',
            populate: null,
          },
          {
            relation: 'launch_season',
            populate: null,
          },
          {
            relation: 'silhouettes',
            populate: null,
          },
          {
            relation: 'trends',
            populate: null,
          },
          {
            relation: 'special_attributes',
            populate: null,
          },
          {
            relation: 'garment_special_attributes',
            populate: null,
          },
          {
            relation: 'garment_special_attributes2',
            populate: null,
          },
          {
            relation: 'weave_structure_type',
            populate: null,
          },
          {
            relation: 'patterns',
            populate: [
              {
                relation: 'website_garment_pattern',
                populate: null,
              },
            ],
          },
          {
            relation: 'color_family',
            populate: null,
          },
          {
            relation: 'product_variants',
            populate: null,
          },
          {
            relation: 'pp_bracket',
            populate: null,
          },
          {
            relation: 'supplier_master',
            populate: [
              {
                relation: 'address',
                populate: null,
              },
            ],
          },
          {
            relation: 'fabric_used_for_products',
            populate: [
              {
                relation: 'fabric',
                populate: null,
              },
              {
                relation: 'supplier_master',
                populate: null,
              },
              {
                relation: 'tna',
                populate: null,
              },
            ],
          },
          {
            relation: 'tna',
            populate: null,
          },
        ],
        filters: {
          fieldsFilterConfig: [
            {
              fieldName: 'id',
              path: 'this',
              operation: 'eq',
            },
            {
              // done
              fieldName: 'launchDrop',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'month',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'sku',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'status',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'object_status',
              path: 'this',
              operation: 'containsi',
            },
            {
              fieldName: 'object_status_no',
              path: 'this',
              operation: 'containsi',
            },
            {
              // done
              fieldName: 'launchName',
              path: 'this.launch_masters',
              operation: 'containsi',
            },
            {
              // done
              fieldName: 'season_id',
              path: 'this.launch_masters.season',
              operation: 'containsi',
            },
            {
              fieldName: 'launchDrop',
              path: 'this.launch_masters',
              operation: 'containsi',
            },

            {
              fieldName: 'launchCat',
              path: 'this.launch_masters',
              operation: 'containsi',
            },
            {
              fieldName: 'productCategoryName',
              path: 'this.product_option_type',
              operation: 'containsi',
            },
            {
              fieldName: 'supplierName',
              path: 'this.supplier_master',
              operation: 'containsi',
            },
            {
              fieldName: 'Indent_file_reference_id',
              path: 'this.indent_sheets',
              operation: 'containsi',
            },
            {
              fieldName: 'techpack_file_reference_id',
              path: 'this.techpacks',
              operation: 'containsi',
            },
            {
              fieldName: 'fabricName',
              path: 'this.fabric_used_for_products.fabric',
              operation: 'containsi',
            },
            {
              fieldName: 'supplierName',
              path: 'this.fabric_used_for_products.supplier_master',
              operation: 'containsi',
            },
          ],
          searchString: searchText?.trim()?.toLowerCase() ?? '',
          currentFilter: [
            'id',
            'launchDrop',
            'month',
            'sku',
            'launchName',
            'season_id',
            'launchCat',
            'productCategoryName',
            'supplierName',
            'fabricName',
            'Indent_file_reference_id',
            'techpack_file_reference_id',
          ],
          andFilter: [
            {
              fieldName: 'object_status',
              operation: 'in',
              searchString: [
                'techpack_complete',
                'variant_complete',
                'bookable',
              ],
            },
          ],
        },
        sort: {
          createdAt: 'desc',
        },
      };
      const data = { data: { requestedAdditionalDetails } };
      const response = await fetch(`${API}/core-product/get-populated-data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${BEARER} ${token}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log(responseData, 'response check fetch all');
      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        // return;

        data1 = await Promise.all(
          responseData?.data?.completeSuccess?.map(async (entry) => {
            // Fetch User Details
            const userDetails = {
              userRefId: entry?.userDetails[0]?.user?.userID,
              userName: entry?.userDetails[0]?.user?.username,
              userEmail: entry?.userDetails[0]?.user?.email,
            };
            // End Fetch User Details

            let launchObj = [];
            if (entry.launch_masters?.length > 0) {
              console.log(entry.launch_masters);
              launchObj = entry.launch_masters.map((launchMasterObject) => {
                console.log(launchMasterObject);
                return {
                  launchRefId: launchMasterObject.id,
                  launchName: launchMasterObject.launchName,
                  launchCategory: launchMasterObject.launchCat,
                  launchMonth: launchMasterObject.launchMonth,
                  launchDrop: launchMasterObject.launchDrop,
                  launchDate: launchMasterObject.launchDate,
                  seasonDetails: {
                    seasonId: launchMasterObject?.season?.season_id,
                    seasonRefId: launchMasterObject?.season?.id,
                  },
                };
              });
            }

            let fabricUtilizedObjArray = [];
            if (entry.fabric_used_for_products?.length > 0) {
              fabricUtilizedObjArray = entry.fabric_used_for_products.map(
                (fabricUtilized) => {
                  let fupId = fabricUtilized.id;
                  // let availableQuantity =
                  //   fabricUtilized.availableQuantity;
                  let consumptionPerUnit = fabricUtilized.consumptionPerUnit;
                  let utilizationQty = fabricUtilized.utilizationQty;
                  let qualityPercentage = fabricUtilized.qualityPercentage;
                  let fabricObject = {
                    fabricId: fabricUtilized?.fabric?.id,
                    fabricName: fabricUtilized?.fabric?.fabricName,
                    fabricCode: fabricUtilized?.fabric?.fabricCode,
                    fabricComposition:
                      fabricUtilized?.fabric?.fabricComposition,
                    fabricCountAndConstruction:
                      fabricUtilized?.fabric?.countAndConstruction,
                    fabricPrice: fabricUtilized?.fabric?.fabricPrice,
                    fabricWeight: fabricUtilized?.fabric?.weight,
                  };
                  let supplierObject = {
                    supplierId: fabricUtilized?.supplier_master?.id,
                    supplierName: fabricUtilized?.supplier_master?.supplierName,
                  };
                  let tnaObject = {
                    tnaId: fabricUtilized?.tna?.id,
                    tnaStatus: fabricUtilized?.tna?.status,
                    startDate: fabricUtilized?.tna?.startDate,
                    tnaTentativeDate: fabricUtilized?.tna?.tentativeEndDate,
                    actualEndDate: fabricUtilized?.tna?.actualEndDate,
                    updatedAt: fabricUtilized?.tna?.updatedAt,
                  };

                  return {
                    fupId,
                    consumptionPerUnit,
                    utilizationQty,
                    qualityPercentage,
                    fabricObject,
                    supplierObject,
                    tnaObject,
                  };
                }
              );
            }

            let indentSheetsObjArray = [];
            if (entry.indent_sheets?.length > 0) {
              console.log(entry.indent_sheets);
              indentSheetsObjArray = entry.indent_sheets.map(
                (indentSheetObject) => {
                  console.log(indentSheetObject);
                  return {
                    indentRefId: indentSheetObject.id,
                    indentReffName: indentSheetObject.Indent_file_reference_id,
                    indentRefLink: indentSheetObject.Indent_file_link,
                    indentDate: indentSheetObject.indent_file_date,
                    indentType: indentSheetObject.indent_type,
                  };
                }
              );
            }

            let techpacksObjArray = [];
            if (entry.techpacks?.length > 0) {
              console.log(entry.indent_sheets);
              techpacksObjArray = entry.techpacks.map((techpackObj) => {
                console.log(techpackObj);
                return {
                  techpackRefId: techpackObj.id,
                  techpackReffName: techpackObj.techpack_file_reference_id,
                  techpackRefLink: techpackObj.techpack_file_link,
                  techpackDate: techpackObj.techpack_file_date,
                  techpackSKU: techpackObj.sku,
                };
              });
            }

            let subColorObjArray = [];
            if (entry.sub_color_lists?.length > 0) {
              console.log(entry.sub_color_lists);
              subColorObjArray = entry.sub_color_lists.map((subColorObj) => {
                console.log(subColorObj);
                return {
                  subColorRefId: subColorObj.id,
                  subColorName: subColorObj.subColorName,
                  filterColorName: subColorObj?.filter_color?.filter_color_name,
                };
              });
            }

            let fitObjArray = [];
            if (entry?.fits_list?.length > 0) {
              console.log(entry.fits_list);
              fitObjArray = entry.fits_list.map((fitObj) => {
                console.log(fitObj);
                return {
                  fitRefId: fitObj?.id,
                  fitName: fitObj?.fit_name,
                };
              });
            }

            let sizeObjArray = [];
            if (entry?.size_list?.length > 0) {
              console.log(entry?.size_list);
              sizeObjArray = entry?.size_list.map((sizeObj) => {
                console.log(sizeObj);
                return {
                  sizeRefId: sizeObj?.id,
                  sizeName: sizeObj?.size_name,
                };
              });
            }

            let patternObjArray = [];
            if (entry?.patterns?.length > 0) {
              console.log(entry?.patterns, 'patterns core product details');
              patternObjArray = entry?.patterns?.map((patternObj) => {
                console.log(patternObj);
                return {
                  patternRefId: patternObj?.id,
                  patternName: patternObj?.patternName,
                };
              });
            }

            let ppBracketObj = {};
            if (entry?.pp_bracket) {
              let ppBracket = entry?.pp_bracket;
              console.log(
                ppBracket,
                'ppBracket Family in core product details'
              );
              ppBracketObj = {
                ppBracketRefId: ppBracket?.id,
                ppBracketName: ppBracket?.pp_bracket_name,
              };
            }

            let specialAttrObjArray = [];
            if (entry?.special_attributes?.length > 0) {
              console.log(entry?.special_attributes);
              specialAttrObjArray = entry?.special_attributes.map(
                (specialAttrObj) => {
                  console.log(specialAttrObj);
                  return {
                    specialAttrRefId: specialAttrObj?.id,
                    specialAttrName: specialAttrObj?.specialAttribute_name,
                  };
                }
              );
            }

            let garmentSpecialAttributesObjectArray = [];
            if (entry?.garment_special_attributes?.length > 0) {
              garmentSpecialAttributesObjectArray =
                entry?.garment_special_attributes?.map((specialAttriObject) => {
                  console.log(
                    'garment Special Attribute : ',
                    specialAttriObject
                  );
                  return {
                    garmentSpecialAttributeRefId: specialAttriObject?.id,
                    garmentSpecialAttributeName:
                      specialAttriObject?.specialAttribute_name,
                  };
                });
            }

            let garmentSpecialAttributes2ObjectArray = [];
            if (entry?.garment_special_attributes2?.length > 0) {
              garmentSpecialAttributes2ObjectArray =
                entry?.garment_special_attributes2?.map(
                  (specialAttriObject) => {
                    console.log(
                      'garment Special Attribute2 : ',
                      specialAttriObject
                    );
                    return {
                      garmentSpecialAttributeRefId: specialAttriObject?.id,
                      garmentSpecialAttributeName:
                        specialAttriObject?.specialAttribute_name,
                    };
                  }
                );
            }

            let silhouetteObjArray = [];
            if (entry?.silhouettes?.length > 0) {
              console.log(entry?.silhouettes);
              silhouetteObjArray = entry?.silhouettes.map((silhouetteObj) => {
                console.log(silhouetteObj);
                return {
                  silhouetteRefId: silhouetteObj?.id,
                  silhouetteName: silhouetteObj?.silhouette_name,
                };
              });
            }

            let supplierDetails = {};
            if (entry?.supplier_master) {
              let supplierObject = entry?.supplier_master;
              console.log('factory supplier check', entry, supplierObject);
              supplierDetails = {
                //productCat -> product option type, example: shirt, crew, pants, etc
                supplierRefId: supplierObject?.id,
                supplierName: supplierObject?.supplierName,
              };
            }

            let tnaDetails = {};
            if (entry?.tna) {
              let tnaObject = entry?.tna;
              tnaDetails = {
                tnaRefId: tnaObject?.id,
                startDate: tnaObject?.startDate,
                tentativeEndDate: tnaObject?.tentativeEndDate,
                actualEndDate: tnaObject?.actualEndDate,
                comments: tnaObject?.comments,
                actionToBeTaken: tnaObject?.actionToBeTaken,
                type: tnaObject?.type,
              };
            }

            let trendObjArray = [];
            if (entry?.trends?.length > 0) {
              console.log(entry?.trends);
              trendObjArray = entry?.trends.map((trendObj) => {
                console.log(trendObj);
                return {
                  trendRefId: trendObj?.id,
                  trendName: trendObj?.trend_name,
                };
              });
            }

            let productOptionTypeObject = {};
            if (entry.product_option_type) {
              let productOptionType = entry.product_option_type;
              productOptionTypeObject = {
                //productCat -> product option type, example: shirt, crew, pants, etc
                productCatRefId: productOptionType?.id,
                productCatName: productOptionType?.productCategoryName,
              };
            }

            let designCollectionObj = {};
            if (entry?.collection) {
              let designCollection = entry?.collection;
              console.log(designCollection);
              designCollectionObj = {
                designCollectionRefId: designCollection?.id,
                designCollectionName: designCollection?.collectionName,
              };
            }

            let designSeasonObj = {};
            if (entry?.design_season) {
              let designSeason = entry?.design_season;
              console.log(designSeason);
              designSeasonObj = {
                designSeasonRefId: designSeason?.id,
                designSeasonName: designSeason?.season_id,
              };
            }

            let launchSeasonObj = {};
            if (entry?.launch_season) {
              let launchSeason = entry?.launch_season;
              console.log(launchSeason);
              launchSeasonObj = {
                launchSeasonRefId: launchSeason?.id,
                launchSeasonName: launchSeason?.season_id,
              };
            }

            let colorFamilyObj = {};
            if (entry?.color_family) {
              let colorFamily = entry?.color_family;
              console.log(colorFamily);
              colorFamilyObj = {
                colorFamilyRefId: colorFamily?.id,
                colorFamilyName: colorFamily?.subColorName,
              };
            }

            let weaveStructureTypeObj = {};
            if (entry?.weave_structure_type) {
              let weaveStructureType = entry?.weave_structure_type;
              console.log(weaveStructureType);
              weaveStructureTypeObj = {
                weaveStructureTypeRefId: weaveStructureType?.id,
                weaveStructureTypeName: weaveStructureType?.weave_type,
              };
            }

            let productVariantArray = [];
            if (entry.product_variants?.length > 0) {
              console.log(entry.product_variants);
              productVariantArray = entry.product_variants.map(
                (productVariantObject) => {
                  console.log(productVariantObject);
                  return {
                    variantRefId: productVariantObject?.id,
                    variantSKU: productVariantObject?.variant_sku,
                    variantSize: productVariantObject?.size,
                    variantSubColor: productVariantObject?.sub_color,
                    variantFit: productVariantObject?.fit,
                    variantCost: productVariantObject?.cost,
                    variantMrp: productVariantObject?.mrp,
                  };
                }
              );
            }

            //   let productOptionList = [];
            //   if (entry.product_option_qties?.length > 0) {
            //
            //     productOptionList = entry.product_option_qties.map(
            //       (productOptionQtyObject) => {
            //         let productOptionObject =
            //           productOptionQtyObject.product_option_type;
            //         let poqId = productOptionQtyObject.id;
            //         let quantity = productOptionQtyObject.quantity;
            //         let poObject = {
            //           productCatName:
            //             productOptionObject.data.productCategoryName,
            //           productCatId: productOptionObject.data.id,
            //         };

            //         return { poqId, quantity, poObject };
            //       }
            //     );
            //   }

            return {
              key: entry.id,
              id: entry.id,
              month: entry.month,
              launchDrop: entry.launchDrop,
              category: productOptionTypeObject?.productCatName,
              quantity: entry.qty,

              sleeve: entry.Sleeve,
              amrp: entry.amrp,
              assumedMRP: entry.assumedMRP,
              fashionCore: entry.fashionCore,
              description: entry.description,
              collection: designCollectionObj,
              sku: entry.sku,
              new_Repeat: entry.new_Repeat,
              proj_disc: entry.proj_disc,
              cogs: entry.cogs,
              total_cogs: entry.total_cogs,
              po_price: entry.po_price,
              cost_of_finance: entry.cost_of_finance,
              payment_modal: entry.payment_modal,
              cogs_percentage: entry.cogs_percentage,
              pp_slab: entry.pp_slab,
              asp: entry.asp,
              supplier_master: supplierDetails,
              tna: tnaDetails,

              //------------
              quality: entry.quality,
              arv: entry.arv,
              total_arv: entry.total_arv,
              target_cogs: entry.target_cogs,
              lifeOccasion: entry.lifeOccasion,
              weight: entry.weight,
              gsm: entry.gsm,
              attributionCategory: entry.attributionCategory,

              knit_woven: entry.knit_woven,
              freshness: entry.freshness,
              designCategory: entry?.designCategory,
              fabric_special_attribute: entry?.fabric_special_attribute,

              launchDetails: launchObj,
              productOptionType: productOptionTypeObject,
              PPBracket: ppBracketObj,
              designSeason: designSeasonObj,
              launchSeason: launchSeasonObj,
              colorFamily: colorFamilyObj,
              color: colorFamilyObj,
              indentSheetDetails: indentSheetsObjArray,
              techpackDetails: techpacksObjArray,
              colorVariantDetails: subColorObjArray,
              sizeVariantDetails: sizeObjArray,
              fitVariantDetails: fitObjArray,
              silhouetteDetails: silhouetteObjArray,
              trendDetails: trendObjArray,
              patternDetails: patternObjArray,
              specialAttributeDetails: specialAttrObjArray,
              garmentSpecialAttributesDetails:
                garmentSpecialAttributesObjectArray,
              garmentSpecialAttributes2Details:
                garmentSpecialAttributes2ObjectArray,
              productVariantDetails: productVariantArray,
              status: entry.status,
              weave_structure: weaveStructureTypeObj.weaveStructureTypeName,
              icons: entry.icons,
              color_depth: entry.color_depth,
              object_status: entry.object_status,
              object_status_no: entry.object_status_no,
              fabricUtilizationDetails: fabricUtilizedObjArray,
              userDetails: userDetails,
              createdAt: entry?.createdAt,
              updatedAt: entry?.updatedAt,
            };
          })
        );

        console.log('original Data fetch all:', responseData);
        console.log('current Data after modification fetch all:', data1);
        // setData(await sortRecordsByMonth(data1));
        const finalDownloadData = data1;

        console.log('final filtered data fetch all:', finalDownloadData);
        return finalDownloadData;
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsDownloading(false);
    }
  };

  const fetchData = async (token, additionalData) => {
    setIsLoading(true);
    try {
      const paginationParameter = `pagination[page]=${
        additionalData?.currentPageNew || currentPage
      }&pagination[pageSize]=${10}&pagination[withCount]=true`;

      const queryString = [
        `filters[$and][0][object_status][$eq]=techpack_complete`,
        `filters[$and][0][object_status][$eq]=variant_complete`,
        `filters[$and][0][object_status][$eq]=bookable`,
        `populate[launch_masters][populate][0]=season`,
        ,
        `populate[tna][populate]=true`,
        `populate[supplier_master][populate]=true`,
        `populate[product_option_type][populate]=true`,
        `populate[indent_sheets][populate]=true`,
        `populate[techpacks][populate]=true`,
        `populate[fabric_used_for_products][populate][1]=fabric`,
        `populate[fabric_used_for_products][populate][2]=supplier_master`,
        `populate[fabric_used_for_products][populate][3]=tna`,
        `populate[sub_color_lists][populate]=true`,
        `populate[fits_list][populate]=true`,
        `populate[size_list][populate]=true`,
        `populate[design_season][populate]=true`,
        `populate[launch_season][populate]=true`,
        `populate[silhouettes][populate]=true`,
        `populate[trends][populate]=true`,
        `populate[special_attributes][populate]=true`,
        `populate[color_family][populate]=true`,
        `populate[product_variants][populate]=true`,
        paginationParameter,
        additionalData?.searchParameters,
        `sort=createdAt:desc`,
      ]
        .filter(Boolean)
        .join('&');

      console.log(
        'search and other option functionality',
        additionalData,
        'query : ',
        `${API}/core-products?${queryString}`
      );

      const response = await fetch(`${API}/core-products?${queryString}`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const responseData = await response.json();
      console.log(responseData, 'response check');

      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        setPaginationData(responseData?.meta?.pagination);
        // return;

        data1 = await Promise.all(
          responseData.data.map(async (entry) => {
            // Fetch User Details
            const userDetails = await getUserdDetailsCreatedBy(
              entry,
              'core-products'
            );
            // End Fetch User Details

            //rrdd
            let launchObj = [];
            if (entry.attributes.launch_masters?.data?.length > 0) {
              console.log(entry.attributes.launch_masters?.data);
              launchObj = entry.attributes.launch_masters?.data.map(
                (launchMasterObject) => {
                  console.log(launchMasterObject);
                  return {
                    launchRefId: launchMasterObject.id,
                    launchName: launchMasterObject.attributes.launchName,
                    launchCategory: launchMasterObject.attributes.launchCat,
                    launchMonth: launchMasterObject.attributes.launchMonth,
                    launchDrop: launchMasterObject.attributes.launchDrop,
                    launchDate: launchMasterObject.attributes.launchDate,
                    seasonDetails: {
                      seasonId:
                        launchMasterObject?.attributes?.season?.data?.attributes
                          ?.season_id,
                      seasonRefId:
                        launchMasterObject?.attributes?.season?.data?.id,
                    },
                  };
                }
              );
            }

            //rrdd
            let fabricUtilizedObjArray = [];
            if (entry.attributes.fabric_used_for_products?.data?.length > 0) {
              fabricUtilizedObjArray =
                entry.attributes.fabric_used_for_products?.data.map(
                  (fabricUtilized) => {
                    let fupId = fabricUtilized.id;
                    // let availableQuantity =
                    //   fabricUtilized.attributes.availableQuantity;
                    let consumptionPerUnit =
                      fabricUtilized.attributes.consumptionPerUnit;
                    let utilizationQty =
                      fabricUtilized.attributes.utilizationQty;
                    let qualityPercentage =
                      fabricUtilized.attributes.qualityPercentage;
                    let fabricObject = {
                      fabricId: fabricUtilized.attributes?.fabric?.data?.id,
                      fabricName:
                        fabricUtilized.attributes?.fabric?.data?.attributes
                          ?.fabricName,
                    };
                    let supplierObject = {
                      supplierId:
                        fabricUtilized.attributes?.supplier_master?.data?.id,
                      supplierName:
                        fabricUtilized.attributes?.supplier_master?.data
                          ?.attributes?.supplierName,
                    };
                    let tnaObject = {
                      tnaId: fabricUtilized.attributes?.tna?.data?.id,
                      tnaStatus:
                        fabricUtilized.attributes?.tna?.data?.attributes
                          ?.status,
                      tnaTentativeDate:
                        fabricUtilized.attributes?.tna?.data?.attributes
                          ?.tentativeEndDate,
                    };

                    return {
                      fupId,
                      consumptionPerUnit,
                      utilizationQty,
                      qualityPercentage,
                      fabricObject,
                      supplierObject,
                      tnaObject,
                    };
                  }
                );
            }

            //rrdd
            let indentSheetsObjArray = [];
            if (entry.attributes.indent_sheets?.data?.length > 0) {
              console.log(entry.attributes.indent_sheets?.data);
              indentSheetsObjArray = entry.attributes.indent_sheets?.data.map(
                (indentSheetObject) => {
                  console.log(indentSheetObject);
                  return {
                    indentRefId: indentSheetObject.id,
                    indentReffName:
                      indentSheetObject.attributes.Indent_file_reference_id,
                    indentRefLink:
                      indentSheetObject.attributes.Indent_file_link,
                    indentDate: indentSheetObject.attributes.indent_file_date,
                    indentType: indentSheetObject.attributes.indent_type,
                  };
                }
              );
            }

            //rrdd
            let techpacksObjArray = [];
            if (entry.attributes.techpacks?.data?.length > 0) {
              console.log(entry.attributes.indent_sheets?.data);
              techpacksObjArray = entry.attributes.techpacks?.data.map(
                (techpackObj) => {
                  console.log(techpackObj);
                  return {
                    techpackRefId: techpackObj.id,
                    techpackReffName:
                      techpackObj.attributes.techpack_file_reference_id,
                    techpackRefLink: techpackObj.attributes.techpack_file_link,
                    techpackDate: techpackObj.attributes.techpack_file_date,
                    techpackSKU: techpackObj.attributes.sku,
                  };
                }
              );
            }

            //rrdd
            let subColorObjArray = [];
            if (entry.attributes.sub_color_lists?.data?.length > 0) {
              console.log(entry.attributes.sub_color_lists?.data);
              subColorObjArray = entry.attributes.sub_color_lists?.data.map(
                (subColorObj) => {
                  console.log(subColorObj);
                  return {
                    subColorRefId: subColorObj.id,
                    subColorName: subColorObj.attributes.subColorName,
                  };
                }
              );
            }

            //rrdd
            let fitObjArray = [];
            if (entry.attributes?.fits_list?.data?.length > 0) {
              console.log(entry.attributes.fits_list?.data);
              fitObjArray = entry.attributes.fits_list?.data.map((fitObj) => {
                console.log(fitObj);
                return {
                  fitRefId: fitObj?.id,
                  fitName: fitObj?.attributes.fit_name,
                };
              });
            }

            //rrdd
            let supplierDetails = {};
            if (entry?.attributes?.supplier_master) {
              let supplierObject = entry?.attributes?.supplier_master;
              supplierDetails = {
                //productCat -> product option type, example: shirt, crew, pants, etc
                supplierRefId: supplierObject?.data?.id,
                supplierName: supplierObject?.data?.attributes?.supplierName,
              };
            }

            //rrdd
            let sizeObjArray = [];
            if (entry.attributes?.size_list?.data?.length > 0) {
              console.log(entry.attributes?.size_list?.data);
              sizeObjArray = entry.attributes?.size_list?.data.map(
                (sizeObj) => {
                  console.log(sizeObj);
                  return {
                    sizeRefId: sizeObj?.id,
                    sizeName: sizeObj?.attributes?.size_name,
                  };
                }
              );
            }

            //rrdd
            let specialAttrObjArray = [];
            if (entry.attributes?.special_attributes?.data?.length > 0) {
              console.log(entry.attributes?.special_attributes?.data);
              specialAttrObjArray =
                entry.attributes?.special_attributes?.data.map(
                  (specialAttrObj) => {
                    console.log(specialAttrObj);
                    return {
                      specialAttrRefId: specialAttrObj?.id,
                      specialAttrName:
                        specialAttrObj.attributes?.specialAttribute_name,
                    };
                  }
                );
            }

            //rrdd
            let silhouetteObjArray = [];
            if (entry.attributes?.silhouettes?.data?.length > 0) {
              console.log(entry.attributes?.silhouettes?.data);
              silhouetteObjArray = entry.attributes?.silhouettes?.data.map(
                (silhouetteObj) => {
                  console.log(silhouetteObj);
                  return {
                    silhouetteRefId: silhouetteObj?.id,
                    silhouetteName: silhouetteObj?.attributes?.silhouette_name,
                  };
                }
              );
            }

            //rrdd
            let trendObjArray = [];
            if (entry.attributes?.trends?.data?.length > 0) {
              console.log(entry.attributes?.trends?.data);
              trendObjArray = entry.attributes?.trends?.data.map((trendObj) => {
                console.log(trendObj);
                return {
                  trendRefId: trendObj?.id,
                  trendName: trendObj?.attributes?.trend_name,
                };
              });
            }

            //rrdd
            let productOptionTypeObject = {};
            if (entry.attributes.product_option_type) {
              let productOptionType = entry.attributes.product_option_type;
              productOptionTypeObject = {
                //productCat -> product option type, example: shirt, crew, pants, etc
                productCatRefId: productOptionType?.data?.id,
                productCatName:
                  productOptionType?.data?.attributes?.productCategoryName,
              };
            }

            //rrdd
            let designSeasonObj = {};
            if (entry?.attributes?.design_season) {
              let designSeason = entry?.attributes?.design_season;
              console.log(designSeason);
              designSeasonObj = {
                designSeasonRefId: designSeason?.data?.id,
                designSeasonName: designSeason?.data?.attributes?.season_id,
              };
            }

            //rrdd
            let launchSeasonObj = {};
            if (entry?.attributes?.launch_season) {
              let launchSeason = entry?.attributes?.launch_season;
              console.log(launchSeason);
              launchSeasonObj = {
                launchSeasonRefId: launchSeason?.data?.id,
                launchSeasonName: launchSeason?.data?.attributes?.season_id,
              };
            }
            //rrdd
            let colorFamilyObj = {};
            if (entry?.attributes?.color_family) {
              let colorFamily = entry?.attributes?.color_family;
              console.log(colorFamily);
              colorFamilyObj = {
                colorFamilyRefId: colorFamily?.data?.id,
                colorFamilyName: colorFamily?.data?.attributes?.colorName,
              };
            }
            //rrdd
            let productVariantArray = [];
            if (entry.attributes.product_variants?.data?.length > 0) {
              console.log(entry.attributes.product_variants?.data);
              productVariantArray = entry.attributes.product_variants?.data.map(
                (productVariantObject) => {
                  console.log(productVariantObject);
                  return {
                    variantRefId: productVariantObject?.id,
                    variantSKU: productVariantObject?.attributes?.variant_sku,
                    variantSize: productVariantObject?.attributes?.size,
                    variantSubColor:
                      productVariantObject?.attributes?.sub_color,
                    variantFit: productVariantObject?.attributes?.fit,
                    variantCost: productVariantObject?.attributes?.cost,
                    variantMrp: productVariantObject?.attributes?.mrp,
                  };
                }
              );
            }

            //   let productOptionList = [];
            //   if (entry.attributes.product_option_qties?.data?.length > 0) {
            //
            //     productOptionList = entry.attributes.product_option_qties?.data.map(
            //       (productOptionQtyObject) => {
            //         let productOptionObject =
            //           productOptionQtyObject.attributes.product_option_type;
            //         let poqId = productOptionQtyObject.id;
            //         let quantity = productOptionQtyObject.attributes.quantity;
            //         let poObject = {
            //           productCatName:
            //             productOptionObject.data.attributes.productCategoryName,
            //           productCatId: productOptionObject.data.id,
            //         };

            //         return { poqId, quantity, poObject };
            //       }
            //     );
            //   }

            //rrdd
            let designCollectionObj = {};
            if (entry?.attributes?.collection) {
              let designCollection = entry?.attributes?.collection;
              console.log(designCollection);
              designCollectionObj = {
                designCollectionRefId: designCollection?.data?.id,
                designCollectionName:
                  designCollection?.data?.attributes?.collectionName,
              };
            }
            //rrdd
            let ppBracketObj = {};
            if (entry?.attributes?.pp_bracket) {
              let ppBracket = entry?.attributes?.pp_bracket;
              console.log(
                ppBracket,
                'ppBracket Family in core product details'
              );
              ppBracketObj = {
                ppBracketRefId: ppBracket?.data?.id,
                ppBracketName: ppBracket?.data?.attributes?.pp_bracket_name,
              };
            }
            //rrdd
            let patternObjArray = [];
            if (entry?.patterns?.length > 0) {
              console.log(entry?.patterns, 'patterns core product details');
              patternObjArray = entry?.patterns?.map((patternObj) => {
                console.log(patternObj);
                return {
                  patternRefId: patternObj?.id,
                  patternName: patternObj?.patternName,
                };
              });
            }
            //rrdd
            let garmentSpecialAttributesObjectArray = [];
            if (
              entry?.attributes?.garment_special_attributes?.data?.length > 0
            ) {
              garmentSpecialAttributesObjectArray =
                entry?.attributes?.garment_special_attributes?.data?.map(
                  (specialAttriObject) => {
                    console.log(
                      'garment Special Attribute : ',
                      specialAttriObject
                    );
                    return {
                      garmentSpecialAttributeRefId: specialAttriObject?.id,
                      garmentSpecialAttributeName:
                        specialAttriObject?.attributes?.specialAttribute_name,
                    };
                  }
                );
            }

            let garmentSpecialAttributes2ObjectArray = [];
            if (
              entry?.attributes?.garment_special_attributes2?.data?.length > 0
            ) {
              garmentSpecialAttributes2ObjectArray =
                entry?.attributes?.garment_special_attributes2?.data?.map(
                  (specialAttriObject) => {
                    console.log(
                      'garment Special Attribute2 : ',
                      specialAttriObject
                    );
                    return {
                      garmentSpecialAttributeRefId: specialAttriObject?.id,
                      garmentSpecialAttributeName:
                        specialAttriObject?.attributes?.specialAttribute_name,
                    };
                  }
                );
            }

            return {
              key: entry.id,
              id: entry.id,
              month: entry.attributes.month,
              launchDrop: entry.attributes.launchDrop,
              category: productOptionTypeObject?.productCatName,
              quantity: entry.attributes.qty,

              sleeve: entry.attributes.Sleeve,
              amrp: entry.attributes.amrp,
              assumedMRP: entry.attributes.assumedMRP,
              fashionCore: entry.attributes.fashionCore,
              description: entry.attributes.description,

              sku: entry.attributes.sku,
              new_Repeat: entry.attributes.new_Repeat,
              proj_disc: entry.attributes.proj_disc,
              cogs: entry.attributes.cogs,
              total_cogs: entry.attributes.total_cogs,
              cogs_percentage: entry.attributes.cogs_percentage,
              pp_slab: entry.attributes.pp_slab,
              supplier_master: supplierDetails,
              asp: entry.attributes.asp,
              quality: entry.attributes.quality,
              arv: entry.attributes.arv,
              total_arv: entry.attributes.total_arv,
              target_cogs: entry.attributes.target_cogs,
              lifeOccasion: entry.attributes.lifeOccasion,
              weight: entry.attributes.weight,
              gsm: entry.attributes.gsm,
              attributionCategory: entry.attributes.attributionCategory,
              pattern: entry.attributes.pattern,
              knit_woven: entry.attributes.knit_woven,
              freshness: entry.attributes.freshness,

              launchDetails: launchObj,
              productOptionType: productOptionTypeObject,
              indentSheetDetails: indentSheetsObjArray,
              techpackDetails: techpacksObjArray,
              status: entry.attributes.status,
              object_status: entry.attributes.object_status,
              object_status_no: entry.attributes.object_status_no,
              fabricUtilizationDetails: fabricUtilizedObjArray,
              // other object fields
              designSeason: designSeasonObj,
              launchSeason: launchSeasonObj,
              colorFamily: colorFamilyObj,
              colorVariantDetails: subColorObjArray,
              sizeVariantDetails: sizeObjArray,
              fitVariantDetails: fitObjArray,
              silhouetteDetails: silhouetteObjArray,
              trendDetails: trendObjArray,
              specialAttributeDetails: specialAttrObjArray,
              productVariantDetails: productVariantArray,
              userDetails: userDetails,
              createdAt: entry?.attributes?.createdAt,
              updatedAt: entry?.attributes?.updatedAt,

              collection: designCollectionObj,

              po_price: entry.attributes?.po_price,
              cost_of_finance: entry.attributes?.cost_of_finance,
              payment_modal: entry.attributes?.payment_modal,
              designCategory: entry?.attributes?.designCategory,
              fabric_special_attribute:
                entry?.attributes?.fabric_special_attribute,
              PPBracket: ppBracketObj,
              patternDetails: patternObjArray,
              garmentSpecialAttributesDetails:
                garmentSpecialAttributesObjectArray,
              garmentSpecialAttributes2Details:
                garmentSpecialAttributes2ObjectArray,
              weave_structure: entry.attributes.weave_structure,
              icons: entry.attributes.icons,
              color_depth: entry.attributes.color_depth,
            };
          })
        );

        console.log('original Data:', responseData);
        console.log('current Data after modification:', data1);

        setData(data1);
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  function getOriginalStatus(statusText, filterOrderStringPrefixer) {
    const statusAllArray = Object.keys(otbRecordStatusLookupObject);
    const searchableStatus = [];
    statusAllArray.forEach((status) => {
      if (
        otbRecordStatusLookupObject[status]?.trim()?.toLowerCase() ===
          statusText ||
        status.trim().toLowerCase() === statusText
      ) {
        searchableStatus.push(status);
      }
    });

    let finalSearchStatusStrign = searchableStatus?.map((status, index) => {
      return `${filterOrderStringPrefixer}[$in][${index}]=${status}`;
    });
    console.log(
      'status filter with lookup',
      finalSearchStatusStrign,
      statusText,
      filterOrderStringPrefixer
    );
    return finalSearchStatusStrign;
  }

  const getSearchParameters = () => {
    let searchParameters = '';
    if (!searchText) {
      return searchParameters;
    }
    // const isNumber = typeof parseInt(searchText) === 'number';
    // console.log('is number test ', isNumber, typeof parseInt(searchText));
    const searchTextFinal = searchText?.trim()?.toLowerCase() ?? '';
    // let statusSerachString = getOriginalStatus(
    //   searchTextFinal,
    //   'filters[$and][1][$or][9][object_status]'
    // );

    searchParameters = [
      `filters[$and][1][$or][0][launchDrop][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][1][month][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][2][sku][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][3][launch_masters][launchName][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][4][launch_masters][season][season_id][$contains]=${searchTextFinal}`,
      `filters[$and][1][$or][5][launch_masters][launchDrop][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][6][launch_masters][launchCat][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][7][product_option_type][productCategoryName][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][8][fabric_used_for_products][supplier_master][supplierName][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][9][fabric_used_for_products][fabric][fabricName][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][10][indent_sheets][Indent_file_reference_id][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][11][techpacks][techpack_file_reference_id][$containsi]=${searchTextFinal}`,
      `filters[$and][1][$or][12][id][$eq]=${searchTextFinal}`,
      `filters[$and][1][$or][13][supplier_master][supplierName][$containsi]=${searchTextFinal}`,
    ]
      .filter(Boolean)
      .join('&');

    return searchParameters;
  };

  useEffect(() => {
    if (authToken) {
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters });
    }
  }, []);

  useEffect(() => {
    console.log('pagination parameters updated', paginationParams);
    if (paginationParams) {
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters });
    } else {
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters });
    }
  }, [paginationParams]);

  useEffect(() => {
    console.log(searchText);
    if (paginationData?.page) {
      setSearchParams({
        page: paginationData?.page,
        pageName: tabName,
        ...(searchText && { searchquery: searchText }),
      });
    }
  }, [paginationData]);

  useEffect(() => {
    console.log(searchText);
    if (searchText == '') {
      setSearchParams({ page: 1, pageName: tabName });
      let searchParameters = getSearchParameters();
      fetchData(authToken, { searchParameters, currentPageNew: 1 });
    } else if (searchText) {
      let searchParameters = getSearchParameters();
      setSearchParams({
        ...(currentPage ? { page: currentPage } : { page: 1 }),
        pageName: tabName,
        ...(searchText && { searchquery: searchText }),
      });
      fetchData(authToken, { searchParameters, currentPageNew: 1 });
    }
  }, [searchText, filterScope]);

  useEffect(() => {
    console.log(editBookingData);
    //setting form data on change of booking edit data and booking Form reference
    bookingForm.setFieldsValue(editBookingData);
  }, [editBookingData, bookingForm]);

  {
    /* delete product with comment */
  }
  useEffect(() => {
    if (editProductDeleteData) {
      console.log(editProductDeleteData);
      cancelProductForm.setFieldsValue(editProductDeleteData);
    }
    //setting form data on change of booking edit data and booking Form reference
  }, [editProductDeleteData, cancelProductForm]);

  const showBookingModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    bookingForm.resetFields();
    setEditBookingData(null);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    bookingForm.resetFields();
    setEditBookingData(null);
    setIsModalOpen(false);
  };

  const fetchSupplierList = async (token) => {
    let optionsData2 = [];
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/suppler-masters?createdAt:desc`, {
        headers: { Authorization: `${BEARER} ${token}` },
      });
      const optionsData = await response.json();

      optionsData2 = optionsData.data.map((entry) => {
        return {
          id: entry.id,
          supplierName: entry.attributes.supplierName,
          supplierType: entry?.attributes?.supplierType,
        };
      });

      setSupplierList(optionsData2);
      console.log('original Supplier master Data:', optionsData);
      console.log('modified Supplier master Data:', optionsData2);
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  {
    /* delete product with comment */
  }
  const showProductDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  const handleProductDeleteOk = () => {
    cancelProductForm.resetFields();
    setEditProductDeleteData(null);
    setIsDeleteModalOpen(false);
  };
  const handleProductDeleteCancel = () => {
    cancelProductForm.resetFields();
    setEditProductDeleteData(null);
    setIsDeleteModalOpen(false);
  };

  const showIndentModal = (record) => {
    console.log('this is inside showIndentModal', record);
    setIndentList(
      record?.indentSheetDetails?.map((indent) => (
        <div>
          <li>{indent?.indentReffName}</li>
          <li>
            <a target="_blank" href={indent?.indentRefLink}>
              {indent?.indentRefLink}
            </a>
          </li>
        </div>
      ))
    );
    setIsIndentModalOpen(true);
  };

  const handleIndentOk = () => {
    // modalform.resetFields();
    // setEditData(null);
    setIsIndentModalOpen(false);
  };
  const handleIndentCancel = () => {
    // modalform.resetFields();
    // setEditData(null);
    setIsIndentModalOpen(false);
  };

  const showTechpackModal = (record) => {
    console.log('this is inside showTechpackModal', record);
    setTechpackList(
      record?.techpackDetails?.map((techpack) => (
        <div>
          <li>{techpack?.techpackReffName}</li>
          <li>
            <a target="_blank" href={techpack?.techpackRefLink}>
              {techpack?.techpackRefLink}
            </a>
          </li>
        </div>
      ))
    );
    setIsTechpackModalOpen(true);
  };

  const handleTechpackOk = () => {
    // modalform.resetFields();
    // setEditData(null);
    setIsTechpackModalOpen(false);
  };
  const handleTechpackCancel = () => {
    // modalform.resetFields();
    // setEditData(null);
    setIsTechpackModalOpen(false);
  };

  const columns = [
    {
      key: 'id',
      title: 'ID',
      dataIndex: 'id',
    },
    {
      key: 'seasonId',
      title: 'Season',
      render: (_, record) => {
        console.log('---season details..', record);
        return record?.launchDetails[0]?.seasonDetails?.seasonId;
      },
    },
    {
      key: 'month',
      title: 'Month',
      dataIndex: 'month',
      sortOrder: sortedInfo.columnKey === 'month' && sortedInfo.order,
    },
    {
      key: 'launchDrop',
      title: 'Launch Drop',
      dataIndex: 'launchDrop',
    },
    {
      key: 'launchDetails',
      title: 'Launch Name/Collection',
      render: (_, record) => {
        return record?.launchDetails[0]?.launchName || 'NA';
      },
    },
    {
      key: 'category',
      title: 'Category',
      dataIndex: 'category',
    },
    {
      key: 'sku',
      title: 'SKU',
      dataIndex: 'sku',
    },
    {
      key: 'quantity',
      title: 'Quantity',
      dataIndex: 'quantity',
    },
    {
      key: 'assumedMRP',
      title: 'Assumed MRP',
      dataIndex: 'assumedMRP',
    },
    {
      key: 'MRP',
      title: 'MRP',
      dataIndex: 'amrp',
    },
    {
      key: 'fabricName',
      title: 'Fabric Name',
      render: (_, record) => {
        return (
          record?.fabricUtilizationDetails[0]?.fabricObject?.fabricName || 'NA'
        );
      },
    },
    {
      key: 'mill_name',
      title: 'Mill info.',
      render: (_, record) => {
        return (
          record?.fabricUtilizationDetails[0]?.supplierObject?.supplierName ||
          'NA'
        );
      },
    },
    {
      key: 'supplierName',
      title: 'Factory Info',
      render: (_, record) => {
        return record?.supplier_master?.supplierName || 'NA';
      },
    },

    {
      key: 'indent_details',
      title: 'Indent Details.',
      render: (_, record) => {
        return record.indentSheetDetails.map((indentInfo) => {
          return (
            <li
              className="popup_element"
              onClick={() => showIndentModal(record)}
            >
              {indentInfo?.indentReffName}
            </li>
          );
        });
      },
    },
    {
      key: 'techpack_details',
      title: 'Techpack Details.',
      render: (_, record) => {
        return record?.techpackDetails?.map((techpackInfo) => {
          return (
            <li
              className="popup_element"
              onClick={() => showTechpackModal(record)}
            >
              {techpackInfo?.techpackReffName}
            </li>
          );
        });
      },
    },
    {
      key: 'userName',
      title: 'Username',
      dataIndex: 'userName',
      render: (_, record) => {
        console.log(record, record?.userDetails?.userName);
        return record?.userDetails?.userName ?? 'NA';
      },
    },
    {
      key: 'createdAt',
      title: 'Created-Date',
      dataIndex: 'createdAt',
      render: (_, record) => {
        // console.log(record, record?.userDetails?.userName);
        return moment(record?.createdAt).format('DD/MM/YYYY') ?? 'NA';
      },
    },
    {
      key: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (_, record) => {
        switch (record.object_status_no) {
          case 6:
            return 'Bookable';
            break;
          case 8:
            return 'Booked';
            break;
          default:
            return record.object_status;
            break;
        }
      },
    },
    {
      key: 'action',
      title: 'Actions',

      render: (_, record) => {
        return (
          <div>
            <div className="ActionColumn">
              <EditOutlined
                style={{ color: 'black' }}
                onClick={() => Edit(record)}
              />

              <AuditOutlined
                style={{ color: 'green', marginRight: 8 }}
                onClick={() => bookProduct(record)}
              />

              <Button
                icon={
                  <DeleteOutlined style={{ color: 'red', marginRight: 8 }} />
                }
                onClick={() => Delete(record)}
              />
            </div>
          </div>
        );
      },
    },
  ];

  const deleteRecord = async (recordID) => {
    const data = {
      data: {
        actionOperation: 'delete',
        status: 'deleted',
        object_status: 'deleted',
        object_status_no: 15,
      },
    };
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/core-products/${recordID}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log(responseData);

      if (responseData.error) {
        message.error('Something went wrong, please try again');
      } else {
        message.success('Record Deleted Successfully');
        fetchData(getToken());
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  {
    /* delete product old */
  }
  // const Delete = (record) => {
  //   Modal.confirm({
  //     title: 'Are you sure you want to delete this',
  //     onOk: () => {
  //       deleteRecord(record.id);
  //     },
  //   });
  // };

  {
    /* delete product with comment */
  }

  const Delete = (record) => {
    setEditProductDeleteData({
      editDeleteId: record.id,
    });
    console.log(record);
    showProductDeleteModal();
  };

  const Edit = (record) => {
    toCoreProductDetails(record);
  };

  const SupplierList =
    supplierList?.map((supplier) => {
      return {
        label: `${supplier.supplierName} - ${supplier.supplierType} `,
        value: supplier.id,
      };
    }) || [];
  //
  const bookProduct = (record) => {
    fetchSupplierList(authToken);

    setEditBookingData({
      supplier_master: record?.supplier_master?.supplierRefId || null,
      startDate:
        (record?.tna?.startDate && moment(record?.tna?.startDate)) || null,
      tentativeEndDate:
        (record?.tna?.tentativeEndDate &&
          moment(record?.tna?.tentativeEndDate)) ||
        null,
      comments: record?.tna?.comments,
      actionToBeTaken: record?.tna?.actionToBeTaken,
      type: record?.tna?.type,
      editId: record.id,
      tnaEditId: record?.tna?.id,
    });
    console.log(record);
    console.log(moment(record?.tna?.startDate));

    showBookingModal();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    console.log('in handle table change', pagination, filters, sorter);
    const { order, columnKey } = sorter;
    setFilterInfo(filters);
    setSortedInfo({ columnKey, order });
    const { current } = pagination;
    setPaginationParams({
      page: pagination.current,
      pageCount: Math.ceil(pagination?.total / pagination?.pageSize) ?? 0,
      pageSize: pagination.pageSize,
      total: pagination.total,
    });
    setSearchParams({
      page: current,
      pageName: tabName,
      ...(searchText && { searchquery: searchText }),
    });
  };

  const resetTable = () => {
    setSortedInfo({});
    setFilterInfo({});
    setSearchText(null);
    setSearchParams({ pageName: tabName });
    setFilterScope('all');
    setAlreadySelectedRows([]);
    // fetchData(authToken);
    let searchParameters = '';
    fetchData(authToken, { searchParameters, currentPageNew: 1 });
  };

  const handleChangeSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleFilterScopeChange = (value) => {
    console.log('setFilterScope', value);
    setFilterScope(value);
  }; // change in filter scope selected by user

  const getFilterOptionArray = (options) => {
    return options.map((option) => {
      return { value: option, label: option };
    });
  }; //

  const filterOptionArray = [...getFilterOptionArray(filterScopeOptionsArray)];

  const otbRecordStatusLookupObject = {
    active: 'Active',
    wip: 'WIP',
    completed: 'Completed',
    confirmed: 'Confirmed',
    fabric_complete: 'Fabric Complete',
    techpack_complete: 'Bookable',
    bookable: 'Bookable',
    booked: 'Booked',
    receiving_due: 'Receiving Due',
    receiving_pending: 'Receiving Pending',
    received: 'Received',
    postponed: 'Postponed',
    canceled: 'Canceled',
    dropped: 'Dropped',
    deleted: 'Deleted',
  };
  const getDisplayableStatus = (sys_status) => {
    return otbRecordStatusLookupObject[sys_status];
  };

  const getFinalFormatedData = async () => {
    const finalDownloadableData = await getFormattedData();
    setDownloadableData(finalDownloadableData);
    setTimeout(() => {
      csvLinkRef.current.link.click(); // Manually trigger CSV download
    }, 600); // Small delay to ensure state update
  };

  const getFormattedData = async () => {
    const downloadData = await fetchDataAll(authToken);
    console.log(downloadData, 'downloading data...');

    let downloadDataFormatted = downloadData.map((row) => {
      console.log(row, 'downloading data row...');

      let fabricUtilsObjectArray1 = [];

      for (
        let index = 0;
        index < row.fabricUtilizationDetails.length;
        index++
      ) {
        const fabricUtilObj = row.fabricUtilizationDetails[index];
        console.log('fabric array', fabricUtilObj);
        fabricUtilsObjectArray1['Fabric' + (index + 1)] = {
          'Fabric Code': fabricUtilObj?.fabricObject?.fabricName,
          'Consumption PerUnit': fabricUtilObj?.consumptionPerUnit,
          Weight: fabricUtilObj?.utilizationQty,
        };
      }

      console.log(
        'fabric_adfjslkdk',
        fabricUtilsObjectArray1,
        fabricUtilsObjectArray1['Fabric1']
      );

      // const fabricUtilsObjectArray = row.fabricUtilizationDetails.map(
      //   (fabricUtilObj, index) => {
      //     const fabricUtilsDetailObject = [];
      //     fabricUtilsDetailObject['Fabric' + index] = {
      //       'Fabric Code': fabricUtilObj?.fabricObject?.fabricName,
      //       'Consumption PerUnit': fabricUtilObj?.consumptionPerUnit,
      //       Weight: fabricUtilObj?.utilizationQty,
      //     };
      //     return fabricUtilsDetailObject;
      //   }
      // );
      // console.log('fabric array', fabricUtilsObjectArray);
      // return {};
      const downloadDataRow = {
        // key: row.id,
        ID: row?.id,
        Season: row?.launchDetails[0]?.seasonDetails?.seasonId,
        'Launch Name': row?.launchDetails
          ?.map((launch) => launch?.launchName)
          ?.join(','),
        Month: row?.month,
        'Launch Drop': row?.launchDrop,
        Category: row?.productOptionType?.productCatName,
        Status: row?.status,
        'Product Status': getDisplayableStatus(row?.object_status),
        SKU: row?.sku,
        Quantity: row?.quantity,
        'Fashion Core': row?.fashionCore,
        'New Repeat': row?.new_Repeat,
        Description: row?.description,
        Collection: row?.collection?.designCollectionName,
        Colors: row?.colorVariantDetails
          ?.map((colorItem) => {
            return colorItem?.subColorName;
          })
          ?.join(','),
        Fits: row?.fitVariantDetails
          ?.map((fitItem) => {
            return fitItem?.fitName;
          })
          ?.join(','),
        Sizes: row?.sizeVariantDetails
          ?.map((sizeItem) => {
            return sizeItem?.sizeName;
          })
          ?.join(','),
        'Color Family': row?.colorFamily?.colorFamilyName,
        'Filter Color Grouping': row?.colorVariantDetails[0]?.filterColorName,
        'Fabric Group':
          row?.fabricUtilizationDetails[0]?.fabricObject?.fabricName,
        'Assumed MRP': row?.assumedMRP,
        'Design Season': row?.designSeason?.designSeasonName,
        'Launch Season': row?.launchSeason?.launchSeasonName,
        'Life Occasion': row?.lifeOccasion,
        Sleeve: row?.sleeve,
        Silhouettes: row?.silhouetteDetails
          ?.map((silhouette) => {
            return silhouette?.silhouetteName;
          })
          ?.join(','),
        'Design Category': row?.designCategory,
        'knit Woven': row?.knit_woven,
        Freshness: row?.freshness,
        'Special Attributes': row?.specialAttributeDetails
          ?.map((specialAttr) => specialAttr?.specialAttrName)
          ?.join(','),

        'Garment Special Attributes': row?.garmentSpecialAttributesDetails
          ?.map((specilaAttri) => {
            return specilaAttri?.garmentSpecialAttributeName;
          })
          ?.join(','),

        'Garment Special Attributes2': row?.garmentSpecialAttributes2Details
          ?.map((specialAttriObject) => {
            return specialAttriObject?.garmentSpecialAttributeName;
          })
          ?.join(','),

        'Fabric Special Attribute': row?.fabric_special_attribute,
        Trends: row?.trendDetails?.map((trend) => trend?.trendName)?.join(','),
        Patterns: row?.patternDetails
          ?.map((pattern) => pattern?.patternName)
          ?.join(','),
        'Attribution Category': row?.attributionCategory,
        Icons: row?.icons,
        Weight: row?.weight,
        'Weave Structure': row?.weave_structure,
        'Color Depth': row?.color_depth,

        // planning data
        AMRP: row?.amrp,
        'Projected Disc': row?.proj_disc,
        ASP: row?.asp,
        ARV: row?.arv,
        'Total ARV': row?.total_arv,
        PPBracket: row?.PPBracket?.ppBracketName,

        // Merch Data
        'Target COGP': row?.target_cogs,
        Factory: row?.supplier_master?.supplierName,
        COGP: row?.cogs,
        'Total COGP': row?.total_cogs,
        'COGP %': row?.cogs_percentage,
        'PO Price': row?.po_price,
        'Cost of Finance': row?.cost_of_finance,
        'Payment Modal': row?.payment_modal,
        'Indent Attached': row?.indentSheetDetails
          ?.map(
            (indentSheetObj) =>
              `${indentSheetObj?.indentRefLink} - ${indentSheetObj?.indentDate} `
          )
          ?.join(','),

        'Techpack Attached': row?.techpackDetails
          ?.map(
            (techpackObj) =>
              `${techpackObj?.techpackRefLink} - ${techpackObj?.techpackDate}`
          )
          ?.join(','),
        // productOptionType: productOptionTypeObject,
        // indentSheetDetails: indentSheetsObjArray,
        // techpackDetails: techpacksObjArray,
        'Fabric Utilized': row?.fabricUtilizationDetails?.map(
          (fabricUtilObj) => {
            return `${fabricUtilObj?.fabricObject?.fabricName} (uses ${fabricUtilObj?.consumptionPerUnit} per unit) `;
          }
        ),

        'Designer Name': row?.userDetails?.userName,
        'Created Date': moment(row?.createdAt).format('DD/MM/YYYY') ?? 'NA',

        // object_status_no: row.object_status_no,
      };

      for (
        let index = 0;
        index < row.fabricUtilizationDetails.length;
        index++
      ) {
        const fabricUtilObj = row.fabricUtilizationDetails[index];
        console.log('fabric array', fabricUtilObj);
        downloadDataRow['Fabric Utilized' + (index + 1)] =
          `Fabric Code : ${fabricUtilObj?.fabricObject?.fabricCode},\n` +
          `Fabric Name: ${fabricUtilObj?.fabricObject?.fabricName},\n` +
          `Fabric Composition: ${fabricUtilObj?.fabricObject?.fabricComposition},\n` +
          
          `Fabric Price: ${fabricUtilObj?.fabricObject?.fabricPrice},\n` +
          `Fabric Weight: ${fabricUtilObj?.fabricObject?.fabricWeight},\n` +
          `Utilization Quantity: ${fabricUtilObj?.utilizationQty},\n` +
          `Weight: ${fabricUtilObj?.utilizationQty},\n` +
          `Mill: ${fabricUtilObj?.supplierObject?.supplierName},\n` +
          `Start Date: ${fabricUtilObj?.tnaObject?.startDate},\n` +
          `Expected Date: ${fabricUtilObj?.tnaObject?.tnaTentativeDate},\n` +
          `Actual Received Date: ${fabricUtilObj?.tnaObject?.actualEndDate}`;
      }
      console.log('27032025 - downloadable data check', downloadDataRow);
      return downloadDataRow;
    });

    console.log(downloadDataFormatted, 'downloading data 2...');
    if (downloadDataFormatted?.length > 0) {
      return downloadDataFormatted;
    } else {
      return [
        {
          ID: 0,
          Season: 'NA',
          'Launch Name': 'NA',
          Month: 'NA',
          'Launch Drop': 'NA',
          Category: 'NA',
          Status: 'NA',
          SKU: 'NA',
          Quantity: 'NA',
          'Fashion Core': 'NA',
          'New Repeat': 'NA',
          Description: 'NA',
          Collection: 'NA',
          Colors: 'NA',
          Fits: 'NA',
          Sizes: 'NA',
          'Color Family': 'NA',
          'Filter Color Grouping': 'NA',
          'Fabric Group': 'NA',
          'Assumed MRP': 'NA',
          'Design Season': 'NA',
          'Launch Season': 'NA',
          'Life Occasion': 'NA',
          Sleeve: 'NA',
          Silhouettes: 'NA',
          Trends: 'NA',
          Patterns: 'NA',

          'Design Category': 'NA',
          'knit Woven': 'NA',
          Freshness: 'NA',
          'Special Attributes': 'NA',
          'Garment Special Attributes': 'NA',
          'Garment Special Attributes2': 'NA',
          'Fabric Special Attribute': 'NA',
          'Attribution Category': 'NA',
          Icons: 'NA',
          Weight: 'NA',
          'Weave Structure': 'NA',
          'Color Depth': 'NA',
          AMRP: 'NA',
          'Projected Disc': 'NA',
          ASP: 'NA',
          ARV: 'NA',
          'Total ARV': 'NA',
          PPBracket: 'NA',
          'Target COGP': 'NA',
          Factory: 'NA',
          'Designer Name': 'NA',
          createdAt: 'NA',
          'Fabric Utilized': 'NA',
        },
      ];
    }
  };

  //   const confirmAllselectedRecords = async () => {
  //     console.log(alreadySelectedRows, 'confirm all selected records func');
  //     setIsLoading(true);
  //     try {
  //       const response = await fetch(
  //         `${API}/product-option/confirm-product-option`,
  //         {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //
  //             Authorization: `Bearer ${getToken()}`,
  //           },
  //           body: JSON.stringify({
  //             data: { selectedProductOptionRecords: alreadySelectedRows },
  //           }),
  //         }
  //       );
  //       const responseData = await response.json();
  //       console.log(responseData);

  //       if (responseData.error) {
  //         message.error('Something went wrong, please try again');
  //       } else {
  //         message.success('All Selected Records are confirmed Successfully');
  //         fetchData(getToken());
  //       }
  //     } catch (error) {
  //       console.error(error);
  //       message.error('Error while fetching Data!');
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   const generateCoreProductForAllselectedRecords = async () => {
  //     console.log(
  //       alreadySelectedRows,
  //       'gen core product all selected records func'
  //     );
  //     setIsLoading(true);
  //     try {
  //       const response = await fetch(
  //         `${API}/product-option/generate-developmentProduct`,
  //         {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json',
  //
  //             Authorization: `Bearer ${getToken()}`,
  //           },
  //           body: JSON.stringify({
  //             data: { selectedProductOptionRecords: alreadySelectedRows },
  //           }),
  //         }
  //       );
  //       const responseData = await response.json();
  //       console.log(responseData);

  //       if (responseData.error) {
  //         message.error('Something went wrong, please try again');
  //       } else {
  //         message.success('completed core Product generation');
  //         fetchData(getToken());
  //       }
  //     } catch (error) {
  //       console.error(error);
  //       message.error('Error while fetching Data!');
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  const addBookingDetails = async (data) => {
    console.log('Booking Data original:', data, Data);

    const coreProductDetails = Data.filter((record) => {
      return record.id === data.editId;
    })[0];
    console.log(
      'selected product:',
      coreProductDetails,
      coreProductDetails.quantity
    );
    // return;
    setSaving(true);
    const valuestna = {
      startDate: data['startDate'].format('YYYY-MM-DD'),
      tentativeEndDate: data['tentativeEndDate'].format('YYYY-MM-DD'),
      core_product: data.editId,
      comments: data.comments,
      actionToBeTaken: data.actionToBeTaken,
      type: data.type,
      editId: data.editId,
      tnaEditId: data.tnaEditId,
    };

    const valuesPOD = {
      total_order_quantity: coreProductDetails.quantity,
      received_qty: 0,
      remaining_qty: coreProductDetails.quantity,
      core_product: data.editId,
    };

    const valuesCP = {
      object_status_no: 8,
      object_status: 'booked',
      supplier_master: data.supplier_master,
      editId: data.editId,
      tnaEditId: data.tnaEditId,
    };

    data = { data: valuestna };

    console.log('Booking valuestna:', valuestna);

    // // return;
    console.log('Booking data core product edit:', data.data.editId);
    console.log('Booking data tna edit:', data.data.tnaEditId);

    if (data.data.tnaEditId) {
      console.log('Booking edit id modal entity :', data.data.tnaEditId);

      //   try {
      //     const response = await fetch(
      //       `${API}/tnas/${data.data.editEntityId_TechPack}`,
      //       {
      //         method: 'PUT',
      //         headers: {
      //           'Content-Type': 'application/json',
      //
      //           Authorization: `Bearer ${authToken}`,
      //         },
      //         body: JSON.stringify(data),
      //       }
      //     );
      //     const responseData = await response.json();
      //     console.log('result recived', responseData);
      //     if (responseData.error) {
      //       message.error('Unable to Update Record, ' + responseData.error);
      //     } else {
      //       message.success('Data saved successfully!');
      //       fetchTechpackList(authToken);
      //       //   toPreviousPage();
      //       handleOkTechPack();
      //     }
      //   } catch (error) {
      //     console.error(Error);
      //     message.error('Error While Updating the Data!');
      //   } finally {
      //     setSaving(false);
      //     // setEditData(null);
      //   }
    } else {
      // create a new record in the database table
      console.log('Booking tna edit id modal entity:', data.data.tnaEditId);
      // return;
      try {
        const response = await fetch(`${API}/tnas/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',

            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify(data),
        });
        const responseData = await response.json();
        console.log(responseData);
        if (responseData.error) {
          errorHandler(responseData, message);
        } else {
          // message.success('Data saved successfully!');

          {
            /**    product order details  */
          }

          try {
            const responsePOD = await fetch(`${API}/product-order-details/`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',

                Authorization: `Bearer ${authToken}`,
              },
              body: JSON.stringify({
                data: valuesPOD,
              }),
            });
            const responseDataPOD = await responsePOD.json();
            console.log(responseDataPOD, 'inside update product order details');
            if (responseDataPOD.error) {
              message.error('Unable to Update Product order details');
            } else {
              // message.success('Data saved successfully!');
              // fetchData(authToken);
            }
          } catch (errorInside) {
            console.log(
              errorInside,
              'error while update product order details'
            );
          }

          try {
            const response1 = await fetch(
              `${API}/core-products/${valuesCP.editId}`,
              {
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',

                  Authorization: `Bearer ${authToken}`,
                },
                body: JSON.stringify({
                  data: valuesCP,
                }),
              }
            );
            const responseData1 = await response1.json();
            console.log(responseData1, 'inside update core product status');
            if (responseData1.error) {
              message.error('Unable to Update Product Status.');
            } else {
              message.success('Data saved successfully!');
              let searchParameters = getSearchParameters();
              fetchData(authToken, { searchParameters });
            }
          } catch (errorInside) {
            console.log(
              errorInside,
              'error while update status of Core product'
            );
          }

          handleOk();
          //   toPreviousPage();
        }
      } catch (error) {
        console.error(Error);
        message.error('Error While Adding Shipping Details!');
      } finally {
        setSaving(false);
      }
    }
  };
  // delete product with comment
  const fabricLiabilityStatusOptionList = fabricLiabilityStatusArray.map(
    (value) => {
      return {
        label: toProperCase(value),
        value: value,
      };
    }
  );

  // const deleteTypeOptionList = Object.keys(deleteTypeOptionArray).map(
  //   (value) => {
  //     return {
  //       label: toProperCase(value),
  //       value: value,
  //     };
  //   }
  // );

  const deleteTypeOptionList = getEligibleOPtionforDeleteType(
    PRODUCTSTAGE[0]
  ).map((value) => {
    return {
      label: toProperCase(value),
      value: value,
    };
  });

  // delete product with comment
  const deleteProductWithFabricLiabilityStatus = async (deleteFormData) => {
    console.log('product delete data :', deleteFormData);
    const deleteRequestObject = DeleteRequestFactory(
      deleteFormData?.delete_type,
      deleteFormData?.fabric_liability_remarks,
      deleteFormData?.fabric_liability_status
    );
    // console.log('product drop data object :', deleteRequestObject);

    // return;

    let recordID = deleteFormData.editDeleteId;
    const data = deleteRequestObject?.buildDeleteProductRequestObject();
    const urlString = deleteRequestObject?.buildDeleteProductURLString();
    console.log(
      'received obje function build test:',
      data,
      `${API}/${urlString + '' + recordID}`
    );
    // return;
    setIsLoading(true);
    try {
      const response = await fetch(`${API}/${urlString + '' + recordID}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',

          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      console.log(responseData);

      if (responseData.error || responseData.errors) {
        errorHandler(responseData, message);
      } else {
        message.success('Record Deleted Successfully');
        fetchData(getToken());
        handleProductDeleteCancel();
      }
    } catch (error) {
      console.error(error);
      message.error('Error while fetching Data!');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <h2>Bookable Products</h2>
      {/*   <Button
        onClick={() => {
          toCoreProductDetails();
        }}
      >
        Add
    </Button> */}

      {/* Table Section */}
      <div className="table">
        {/* Filter search Section */}
        <div className="filterContainer">
          <div className="tableSearchSection">
            <Select
              disabled={true}
              defaultValue="all"
              className="filterScopeSelect"
              onChange={handleFilterScopeChange}
              options={filterOptionArray}
            />

            <Input
              placeholder="Enter Search Text"
              onChange={handleChangeSearch}
              type="text"
              allowClear
              value={searchText}
            ></Input>
            <Button onClick={resetTable}>Reset</Button>
            <Button
              style={{ backgroundColor: 'greenyellow', color: 'white' }}
              onClick={getFinalFormatedData}
            >
              Download {isDownloading && <Spin size="small" />}
            </Button>
            <CSVLink
              data={downloadableData}
              filename={
                'Bookable-Product-list-' +
                moment(new Date()).format('DD-MM-YYYY')
              }
              ref={csvLinkRef}
              style={{ display: 'none' }}
            />
          </div>
        </div>
        {isLoading ? (
          <Spin size="large" />
        ) : (
          <Table
            dataSource={Data}
            columns={columns}
            onChange={handleTableChange}
            pagination={{
              current: currentPage,
              pageSize: paginationData?.pageSize,
              total: paginationData?.total,
              position: ['bottomCenter'],
            }}
            rowSelection={{
              type: 'checkbox',
              selectedRowKeys: alreadySelectedRows,
              onChange: (keys) => {
                setAlreadySelectedRows(keys);
              },
              onSelect: (record) => {
                console.log(record, 'selected row ');
              },
              selections: [
                Table.SELECTION_NONE,
                Table.SELECTION_ALL,

                //   {
                //     key: 'confirmSelected',
                //     text: 'Confirm All Selected Rows',
                //     onSelect: (allkeys) => {
                //       console.log('confirmSelected');
                //       confirmAllselectedRecords();
                //     },
                //   },
                //   {
                //     key: 'ConfirmCreateCoreProduct',
                //     text: 'Confirm and Create Core Product',
                //     onSelect: (allkeys) => {
                //       console.log('confirmSelected');
                //       generateCoreProductForAllselectedRecords();
                //     },
                //   },
              ],
            }}
          />
        )}
      </div>
      <Modal
        title="Shipping Details"
        visible={isModalOpen}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
      >
        <Card className="addProduct_page_card">
          <Form
            form={bookingForm}
            layout="vertical"
            onFinish={addBookingDetails}
          >
            <Row gutter={[16, 16]}>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Factory"
                  name="supplier_master"
                  rules={[
                    {
                      required: true,
                      message: 'Factory is Required!',
                    },
                  ]}
                >
                  <Select
                    showSearch
                    onSearch={(value) => {
                      // console.log('searching...', value);
                    }}
                    placeholder="Select "
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.trim().toLowerCase())
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '')
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    options={SupplierList.filter((supplier_item) =>
                      supplier_item?.label?.toLowerCase()?.includes('factory')
                    )}
                  />
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Order Placed Date"
                  name="startDate"
                  rules={[
                    {
                      type: 'object',
                      required: true,
                      message: 'Order Placed Date is required',
                    },
                  ]}
                >
                  <DatePicker format={dateFormat} />
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Goods Expected Received Date"
                  name="tentativeEndDate"
                  rules={[
                    {
                      type: 'object',
                      required: true,
                      message: 'Goods Expected Received Date is required',
                    },
                  ]}
                >
                  <DatePicker format={dateFormat} />
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Comments"
                  name="comments"
                  rules={[
                    {
                      type: 'string',
                    },
                  ]}
                >
                  <Input.TextArea rows={3} placeholder="Comments" />
                </Form.Item>
              </Col>
              {/** * Remove Action to be taken Attribute
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Action To Be Taken"
                  name="actionToBeTaken"
                  rules={[
                    {
                      type: 'string',
                    },
                  ]}
                >
                  <Input.TextArea rows={3} placeholder="Action To Be Taken" />
                </Form.Item>
              </Col>
              * * * */}
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Type"
                  name="type"
                  initialValue="product"
                  hidden={true}
                >
                  <Select placeholder="Select Type">
                    <Select.Option value="product">Product</Select.Option>
                    <Select.Option value="fabric">Fabric</Select.Option>
                    <Select.Option value="pss">PSS</Select.Option>
                    <Select.Option value="photoshoot">
                      Photo Shoots
                    </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Form.Item label="EditId" hidden={true} name="editId">
                <Input type="text" />
              </Form.Item>
              <Form.Item label="tnaEditId" hidden={true} name="tnaEditId">
                <Input type="text" />
              </Form.Item>
            </Row>
            <Button
              className="addProduct_save_btn"
              htmlType="submit"
              type="primary"
              size="large"
              loading={saving}
            >
              {saving ? <>Saving</> : 'Save'}
            </Button>
          </Form>
        </Card>
      </Modal>

      {/* delete product with comment */}
      <Modal
        title="Delete Product"
        visible={isDeleteModalOpen}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        onOk={handleProductDeleteOk}
        onCancel={handleProductDeleteCancel}
        width={1000}
      >
        <Card className="addProduct_page_card">
          <Form
            form={cancelProductForm}
            layout="vertical"
            onFinish={deleteProductWithFabricLiabilityStatus}
          >
            <Row gutter={[16, 16]}>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  shouldUpdate={(prevValues, currentValues) => {
                    console.log(prevValues, currentValues, 'check values ');
                    return (
                      prevValues.product_stage_id !==
                      currentValues.product_stage_id
                    );
                  }}
                >
                  {({ getFieldValue }) => {
                    console.log(
                      getFieldValue('product_stage_id'),
                      'product Stage Id in CPL'
                    );
                    const product_stage_id = getFieldValue('product_stage_id');
                    const deleteTypeOptionListNew =
                      getEligibleOPtionforDeleteType(
                        product_stage_id < 6 ? 5 : 6
                      ).map((value) => {
                        return {
                          label: toProperCase(value),
                          value: value,
                        };
                      });
                    return (
                      <Form.Item label="Select Delete Type" name="delete_type">
                        <Select
                          showSearch
                          onSearch={(value) => {
                            // console.log('searching...', value);
                          }}
                          placeholder="Select "
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            (option?.label ?? '')
                              .toLowerCase()
                              .includes(input.trim().toLowerCase())
                          }
                          options={deleteTypeOptionListNew}
                        />
                      </Form.Item>
                    );
                  }}
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Select Fabric Status"
                  name="fabric_liability_status"
                  rules={[
                    {
                      required: true,
                      message: 'This is a required field',
                    },
                  ]}
                >
                  <Select
                    showSearch
                    onSearch={(value) => {
                      // console.log('searching...', value);
                    }}
                    placeholder="Select "
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? '')
                        .toLowerCase()
                        .includes(input.trim().toLowerCase())
                    }
                    options={fabricLiabilityStatusOptionList}
                  />
                </Form.Item>
              </Col>
              <Col md={8} lg={8} sm={24} xs={24}>
                <Form.Item
                  label="Fabric Liability Remarks"
                  name="fabric_liability_remarks"
                  rules={[
                    {
                      required: true,
                      message: 'This is a required field',
                      type: 'string',
                    },
                  ]}
                >
                  <Input.TextArea rows={3} placeholder="Comments" />
                </Form.Item>
              </Col>

              <Form.Item label="EditId" hidden={true} name="editDeleteId">
                <Input type="text" />
              </Form.Item>
            </Row>
            <Button
              className="addProduct_save_btn"
              htmlType="submit"
              type="primary"
              size="large"
            >
              {saving ? (
                <>
                  <Spin size="small" /> Deleting
                </>
              ) : (
                'Delete'
              )}
            </Button>
          </Form>
        </Card>
      </Modal>
      <Modal
        title="Indents List"
        // open={isIndentModalOpen}
        visible={isIndentModalOpen}
        onOk={handleIndentOk}
        onCancel={handleIndentCancel}
      >
        <ul>
          {indentList.map((indentReffName) => (
            <li key={indentReffName}>{indentReffName}</li>
          ))}
        </ul>
      </Modal>

      <Modal
        title="techpacks List"
        visible={isTechpackModalOpen}
        onOk={handleTechpackOk}
        onCancel={handleTechpackCancel}
      >
        <ul>
          {techpackList.map((techpackReffName) => (
            <li key={techpackReffName}>{techpackReffName}</li>
          ))}
        </ul>
      </Modal>
    </div>
  );
};
export default BookableProductList;
